import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import NumberedTabsLabel from './NumberedTabsLabel';
import { sxCheckedNumberedTab, sxCheckedNumeredTabAccessibility, sxTabs, sxTabsAccessibility, sxTabsBox, sxUncheckedNumberedTab } from './sxProps';
import './styles.css';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const NumberedTabs: React.FC<{
  steps: { value: number, label: string }[];
  currentStep: number;
}> = ({ steps, currentStep }) => {

  const { contrastMode, textStyleAccessibility } = useAccessibility();

  const tab = (step: number, currentStep: number, text: string, checked: boolean, current: boolean) => (
    <Tab
      key={step}
      value={step}
      label={
        <NumberedTabsLabel
          step={step}
          checked={checked}
          text={text}
          current={current}
          currentStep={currentStep}
        />
      }
      sx={checked ? (contrastMode ? sxCheckedNumeredTabAccessibility : sxCheckedNumberedTab) : sxUncheckedNumberedTab}
      disableRipple
      disableTouchRipple
      disableFocusRipple
    />
  );

  return (
    <Box sx={sxTabsBox}>
      <Tabs
        value={currentStep} sx={ contrastMode ? sxTabsAccessibility : sxTabs } textColor="inherit"
        variant='scrollable'
        scrollButtons={false}
        allowScrollButtonsMobile={false}
      >
        {steps.map((step) => tab(step.value, currentStep, step.label, currentStep > step.value, currentStep === step.value))}
      </Tabs>
    </Box>
  );
};

export default NumberedTabs;